import { render, staticRenderFns } from "./falha.vue?vue&type=template&id=05025dd0&scoped=true"
import script from "./falha.vue?vue&type=script&lang=js"
export * from "./falha.vue?vue&type=script&lang=js"
import style0 from "./falha.vue?vue&type=style&index=0&id=05025dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05025dd0",
  null
  
)

export default component.exports